import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function ClosingCTA() {
    return (
        <section className="py-20 md:py-32 border-t border-warm-gray-200">
            <div className="max-w-2xl">
                <p className="text-xl md:text-2xl font-fraunces text-warm-gray-700 mb-8 leading-relaxed">
                    If you're looking for a designer who values intention over noise,
                    <br className="hidden md:block" />
                    I'd love to talk.
                </p>

                <Link
                    to="/contact"
                    className="link-arrow text-lg font-medium group"
                >
                    Get in touch
                    <ArrowRight
                        size={20}
                        className="group-hover:translate-x-2 transition-transform duration-300"
                    />
                </Link>
            </div>
        </section>
    );
}
